module.exports = __webpack_public_path__ + "static/media/12-aermel_kittel.af9e6038.jpg";